import styled from 'styled-components';

/** Right-aligned submit/cancel pair shared by the report forms. */
export const FormActions = styled.div`
  display: flex;
  button:first-child {
    margin: 0 0.5rem 0 auto;
  }
`;
